export const BAGGAGE_BENEFIT_IMAGES = {
  amexGold: 'assets/images/baggage-benefit/amex-gold.png',
  amexPlatinum: 'assets/images/baggage-benefit/amex-platinum.png',
  amex: 'assets/images/baggage-benefit/amex.png',
  inbursaAscend: 'assets/images/baggage-benefit/inbursa-ascend.png',
  inbursaDebito: 'assets/images/baggage-benefit/inbursa-debito.png',
  inbursaElevate: 'assets/images/baggage-benefit/inbursa-elevate.png',
  inbursaHorizon: 'assets/images/baggage-benefit/inbursa-horizon.png',
  santanderInfinite: 'assets/images/baggage-benefit/santander-infinite.png',
  santanderPlatinum: 'assets/images/baggage-benefit/santander-platinum.png',
  santander: 'assets/images/baggage-benefit/santander.png',
} as const;

export const BENEFIT_ICON_CONFIG = [
  { code: 'AMXGRN', icon: BAGGAGE_BENEFIT_IMAGES.amex },
  { code: 'AMXGLD', icon: BAGGAGE_BENEFIT_IMAGES.amexGold },
  { code: 'AMXPLT', icon: BAGGAGE_BENEFIT_IMAGES.amexPlatinum },
  { code: 'SFIASC', icon: BAGGAGE_BENEFIT_IMAGES.inbursaAscend },
  { code: 'SFIASA', icon: BAGGAGE_BENEFIT_IMAGES.inbursaAscend },
  { code: 'SFIDBT', icon: BAGGAGE_BENEFIT_IMAGES.inbursaDebito },
  { code: 'SFIELE', icon: BAGGAGE_BENEFIT_IMAGES.inbursaElevate },
  { code: 'SFIELA', icon: BAGGAGE_BENEFIT_IMAGES.inbursaElevate },
  { code: 'SFIHRZ', icon: BAGGAGE_BENEFIT_IMAGES.inbursaHorizon },
  { code: 'SFIHRA', icon: BAGGAGE_BENEFIT_IMAGES.inbursaHorizon },
  { code: 'SECLAS', icon: BAGGAGE_BENEFIT_IMAGES.santander },
  { code: 'SEIFNT', icon: BAGGAGE_BENEFIT_IMAGES.santanderInfinite },
  { code: 'SEPLAT', icon: BAGGAGE_BENEFIT_IMAGES.santanderPlatinum },
];
